import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";


export class QuestShow extends Cloneable {
    static NONE = new QuestShow(0, "NONE");
    static DEFAULT = new QuestShow(1, "DEFAULT");
    static DETAILS = new QuestShow(2, "DETAILS");

    static _values = [
        this.NONE,
        this.DEFAULT,
        this.DETAILS
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, QuestShow.getValue(id));
        });
    }

    static getValues() {
        return QuestShow._values;
    }

    static getValue(id) {
        let value = QuestShow._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof QuestShow) {
            return QuestShow._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new QuestShow());
        } else if (target instanceof QuestShow) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(QuestShow, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});